export default "__VITE_ASSET__CtsKQUq6__"